import Swiper from "swiper";
import { Pagination, Autoplay, A11y } from "swiper";
import { initNeosEventItemCreated } from "../../../Assets/Scripts/neosEvents";
import { initNeosEventItemSelected } from "../../../Assets/Scripts/neosEvents";

export function stageImageSwiper() {
    document.querySelectorAll(".stageimage--swiper").forEach((slider) => {
        const isNeosBackend = document.body.classList.contains("neos-backend");
        const controlBtn = slider.querySelector(".swiper-autoplay-toggle");

        const swiperItems = Array.from(slider.querySelectorAll(".swiper-slide"));
        if (swiperItems.length <= 1) {
            return;
        }

        const swiper = new Swiper(slider, {
            modules: [Pagination, Autoplay, A11y],
            allowTouchMove: !isNeosBackend,
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            resizeObserver: false,
            observer: false,
            observeParents: false,
            observeSlideChildren: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
            navigation: {
                nextEl: ".swiper-navigation-next",
                prevEl: ".swiper-navigation-prev",
            },
        });

        if (slider.hasAttribute("data-autoplay") && !isNeosBackend) {
            new IntersectionObserver((entries, observer) => {
                if (entries[0].isIntersecting) {
                    observer.disconnect();
                    swiper.params.autoplay = {
                        delay: 5000,
                    };
                    swiper.autoplay.start();
                }
            }).observe(slider);
        }

        if (controlBtn && !isNeosBackend) {
            let isPlaying = true;

            controlBtn.addEventListener("click", () => {
                if (isPlaying) {
                    swiper.autoplay.stop();
                    controlBtn.setAttribute("aria-pressed", "false");
                    controlBtn.setAttribute("title", "Slideshow abspielen");
                    controlBtn.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.3 47.3">
                            <path d="M44,21.5L10.4,1.8c-1.9-1.1-4,.3-4,2.4v38.7c0,2.2,2.2,3.2,4,2.4l33.6-19.4c1.9-.8,1.9-3.5,0-4.6v.2Z"/>
                        </svg>
                        <span class="sr-only">Slideshow abspielen</span>`;
                } else {
                    swiper.autoplay.start();
                    controlBtn.setAttribute("aria-pressed", "true");
                    controlBtn.setAttribute("title", "Slideshow pausieren");
                    controlBtn.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.3 47.3">
                            <rect x="8.3" y="1.1" width="11.3" height="44.6" rx="3.5" ry="3.5"/>
                            <rect x="27.8" y="1.1" width="11.3" height="44.6" rx="3.5" ry="3.5"/>
                        </svg>
                        <span class="sr-only">Slideshow pausieren</span>`;
                }
                isPlaying = !isPlaying;
            });
        }


        // Fokussteuerung
        slider.addEventListener("keydown", (event) => {
            if (event.key !== "Tab") return;

            const activeElement = document.activeElement;
            const currentSlide = activeElement.closest(".swiper-slide");

            if (!currentSlide) return;

            const focusableElements = Array.from(currentSlide.querySelectorAll("button, a, input, select, textarea"));
            const currentIndex = focusableElements.indexOf(activeElement);
            const lastSlideIndex = swiperItems.length - 1;
            const currentSlideIndex = swiperItems.indexOf(currentSlide);

            // Wenn kein gültiger Index vorhanden ist, beenden
            if (currentIndex === -1) return;

            let nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

            // **TAB rauslassen, wenn wir am Ende sind**
            if (!event.shiftKey && currentSlideIndex === lastSlideIndex && nextIndex >= focusableElements.length) {
                return; // Browser darf normalen Tab durchführen!
            }

            // **SHIFT + TAB rauslassen, wenn wir am Anfang sind**
            if (event.shiftKey && currentSlideIndex === 0 && nextIndex < 0) {
                return; // Browser darf normalen Shift+Tab durchführen!
            }

            // Wenn wir innerhalb des Swipers bleiben -> Swiper Slide wechseln
            event.preventDefault();

            let nextSlideIndex = currentSlideIndex;
            if (nextIndex < 0) {
                nextSlideIndex = Math.max(0, currentSlideIndex - 1);
                nextIndex = swiperItems[nextSlideIndex].querySelectorAll("button, a, input, select, textarea").length - 1;
            } else if (nextIndex >= focusableElements.length) {
                nextSlideIndex = Math.min(lastSlideIndex, currentSlideIndex + 1);
                nextIndex = 0;
            }

            swiper.slideTo(nextSlideIndex);

            setTimeout(() => {
                const nextSlide = swiperItems[nextSlideIndex];
                const newFocusableElements = Array.from(nextSlide.querySelectorAll("button, a, input, select, textarea"));
                if (newFocusableElements[nextIndex]) {
                    newFocusableElements[nextIndex].focus();
                }
            }, 100);
        });
        
        initNeosEventItemCreated(swiper, slider);
        initNeosEventItemSelected(swiper, slider);
    });
}

stageImageSwiper();

